import React from 'react'

import classes from './styles'

const Button = ({ onClick, disabled, children }) => {
  const disabledClass = disabled ? classes.disabled : ''
  const handler = disabled ? () => {} : onClick

  return (
    <div className={classes.buttonWrapper}>
      <div
        onClick={handler}
        className={[classes.button, disabledClass].join(' ')}
      >
        {disabled ?
          <img
            className={[classes.image, 'main-image'].join(' ')}
            src="https://10years.lifehacker.ru/static/images/button_disable.svg"
            alt=""
          />
          :
          <div>
            <img
              className={[classes.image, 'main-image'].join(' ')}
              src="https://10years.lifehacker.ru/static/images/button.svg"
              alt=""
            />

            <img
              className={[classes.image, 'hover-image'].join(' ')}
              src="https://10years.lifehacker.ru/static/images/button_hover.svg"
              alt=""
            />
          </div>
        }


        <div className={classes.text}>
          <div>
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

Button.propTypes = {}

export default Button


// WEBPACK FOOTER //
// ./src/components/Button/Button.jsx